import { ArticleSection } from "@/types/articleEntryData.types";
import { FILL_IN_TABLE_KEY } from "@FillInTableContainer/shared/constants/fillInTableKey";

export const IS_NOT_EDITABLE_SHELL_KEYS: Record<ArticleSection, string[]> = {
  [FILL_IN_TABLE_KEY.ClinicalTrials]: [],
  [FILL_IN_TABLE_KEY.ClinicalTrialStatus]: [],
  [FILL_IN_TABLE_KEY.CompanyWebsiteVariousPages]: [],
  [FILL_IN_TABLE_KEY.Regulatory]: [],
  [FILL_IN_TABLE_KEY.Deals]: [],
  [FILL_IN_TABLE_KEY.ExpeditedProgram]: [],
  [FILL_IN_TABLE_KEY.VentureCapital]: [],
  [FILL_IN_TABLE_KEY.Publication]: ["Originator/Developer"],
  [FILL_IN_TABLE_KEY.PublicationJournal]: [],
  [FILL_IN_TABLE_KEY.ConferenceSchedule]: [],
  [FILL_IN_TABLE_KEY.DealFiling]: [],
  [FILL_IN_TABLE_KEY.FundingFiling]: [],
  [FILL_IN_TABLE_KEY.CTG]: ["Phase", "Originator/Developer"],
};
